// extracted by mini-css-extract-plugin
module.exports = {"cover":"HeaderBlock_cover__2BveW","wrap":"HeaderBlock_wrap__uyRMo","header":"HeaderBlock_header__1LiZh","descr":"HeaderBlock_descr__GlBxb"};